import React from 'react'

const UploadIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='52'
      height='42'
      viewBox='0 0 52 42'
      fill='none'>
      <path
        d='M10.5975 16.3387C5.09375 17.6475 1 22.5962 1 28.5C1 35.4037 6.59625 41 13.5 41C14.6838 41 15.83 40.835 16.9162 40.5275M41.0688 16.3387C46.5725 17.6475 50.665 22.5962 50.665 28.5C50.665 35.4037 45.0687 41 38.165 41C36.9812 41 35.835 40.835 34.75 40.5275M41 16C41 7.71625 34.2837 1 26 1C17.7163 1 11 7.71625 11 16M17.3313 25.8513L26 17.155L34.915 26M26 38.5V21.5775'
        stroke='#9CA6B1'
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  )
}

export default UploadIcon
